module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kLAjS"))).then(() => parcelRequire('1iHdE'));